import "@olmokit/core/debug/api";
import "@olmokit/core/reboot/index.scss";
import "@olmokit/core/grid/index.scss";
import "@olmokit/core/typography/reset.scss";
import "@olmokit/core/icon/index.scss";
import { CookiesBanner } from "@olmokit/core/cookies/banner";
import LazyLoad from "@olmokit/core/lazy";
import "@olmokit/core/img";
import "components/Image";
import { Footer } from "components/Footer";
import initAuthDialog from "components/Dialog/Auth/init";
import promptAuthDialog from "components/Dialog/Auth/prompt";
import "utils/btn.scss";
import "utils/cta.scss";
import "utils/fonts.scss";
import "utils/logo.scss";
import "utils/type.scss";
import "./index.scss";
import { ecommerceTackClick } from "components/Datalayer";

CookiesBanner("cookies_accepted");
new LazyLoad();
Footer();
initAuthDialog();
promptAuthDialog();

// utm_source for Salesforce inherited from AP
let url = window.location.href;
let urlUrl = new URL(url);
let params = new URLSearchParams(urlUrl.search.slice(1));
for (let p of params) {
    if(p[0] == "utm_source"){
        localStorage.setItem('utm_source', p[1]);
    }
}

ecommerceTackClick();